<div [innerHTML]="htmlContent | safeHtml"></div>
